export default "__VITE_ASSET__587cf44e__"